export default {
  path: "/SectionContent/LocationIdentificationTips",
  name: "Location Identification Tips",
  htmlContent: "location_identification_tips.html",
  headings: [
    {
      id: "IdentifyingIntersectionCrashesForLocationAtAreaOfImpact",
      text: "Identifying Intersection Crashes for Location at Area of Impact",
      type: "heading",
    },
    {
      id: "IdentifyingInterstateCrashLocation",
      text: "Identifying Interstate Crash Location",
      type: "heading",
    },
    {
      id: "LocatingCrashesOnInterstateEntranceExitRamp",
      text: "Locating Crashes on Interstate Entrance/Exit Ramp",
      type: "heading",
    },
    { id: "ObtainingCrashGPSLocation", text: "Obtaining Crash GPS Location", type: "heading" },
  ],
};
